import { INavData } from '@coreui/angular-pro';

export const navItems: INavData[] = [
  {
    title: true,
    name: 'Configuración de Rutas y Tasas'
  },
  {
    name: 'Gestión de Horarios',
    url: '/pages/schedules',
    iconComponent: { name: 'cil-clock' },
    attributes: { permission: 'Configurations' }
  },
  {
    name: 'Configurar Rutas por Países',
    url: '/pages/country-routes',
    iconComponent: { name: 'cil-map' },
    attributes: { permission: 'CountryRoutes' }
  },
  {
    name: 'Listado de Rutas por Origen',
    url: '/pages/routes-by-origin',
    iconComponent: { name: 'cil-list' },
    attributes: { permission: 'RoutesByOrigin' }
  },
  {
    title: true,
    name: 'Gestión de Clientes'
  },
  {
    name: 'Validar Identidad',
    url: '/pages/clients',
    iconComponent: { name: 'cil-user' },
    attributes: { permission: 'ValidateIdentity' }
  },
  {
    name: 'Receptores',
    url: '/pages/receptors',
    iconComponent: { name: 'cil-people' },
    attributes: { permission: 'Receptors' }
  },
  {
    title: true,
    name: 'Gestionar Ordenes'
  },
  {
    name: 'Listado de Ordenes',
    url: '/pages/orders',
    iconComponent: { name: 'cil-list' },
    attributes: { permission: 'Orders' }
  },
  {
    name: 'Conciliación Bancaria',
    url: '/pages/bank-conciliation',
    iconComponent: { name: 'cil-bank' },
    attributes: { permission: 'FintocConciliation' }
  },
  {
    name: 'Cierres Diarios',
    url: '/pages/daily-closures',
    iconComponent: { name: 'cil-calculator' },
    attributes: { permission: 'DailyClosures' }
  },
  {
    title: true,
    name: 'Configuraciones Bancarias'
  },
  {
    name: 'Configuración Bancos',
    url: '/pages/banks',
    iconComponent: { name: 'cil-bank' },
    attributes: { permission: 'Banks' }
  },
  {
    name: 'Tipos de Cuenta',
    url: '/pages/account-types',
    iconComponent: { name: 'cil-wallet' },
    attributes: { permission: 'AccountTypes' }
  },
  {
    name: 'Campos de Banco',
    url: '/pages/fields',
    iconComponent: { name: 'cil-list' },
    attributes: { permission: 'Fields' }
  },
  {
    title: true,
    name: 'Configuraciones Bancarias Cambios Polar'
  },
  {
    name: 'Bancos Polares',
    url: '/pages/polar-banks',
    iconComponent: { name: 'cil-bank' },
    attributes: { permission: 'PolarBanks' }
  },
  {
    name: 'Tipos de Transacción',
    url: '/pages/transaction-types',
    iconComponent: { name: 'cil-credit-card' },
    attributes: { permission: 'TransactionTypes' }
  },
  {
    title: true,
    name: 'Configuraciones Generales'
  },
  {
    title: true,
    name: 'Usuarios y Permisos'
  },
  {
    name: 'Permisos y Roles',
    url: '/pages/permissions',
    iconComponent: { name: 'cil-lock-locked' },
    attributes: { permission: 'Permissions' }
  },
  {
    name: 'Usuarios',
    url: '/pages/users',
    iconComponent: { name: 'cil-user' },
    attributes: { permission: 'Users' }
  },
  {
    name: 'Solicitudes de Reactivación',
    url: '/pages/restore-requests',
    iconComponent: { name: 'cil-user-follow' },
    attributes: { permission: 'Users' }
  }
];
